import gql from 'graphql-tag';

export const GET_DW_ENTITY_CONTACT_OLD = gql`
	query GetDWEntityContactOld($entity_id: bigint!) {
		syncarto_dw_entity_contact(where: {entity_id: {_eq: $entity_id }}) {
			contact {
			  email
			  first_name
			  id
			  last_name
			  phonenumber
			  phonenumber2
			}
		}
	}
`;
export const GET_DW_ENTITY_CONTACT = gql`
	query GetDWEntityContact($entity_id: bigint!) {
		syncarto_dw_entity_contact(where: {entity_id: {_eq: $entity_id }}) {
			contact {
				email
				name
				id
				phonenumber
				phonenumber2
				__typename
			}    
			contact_type {
				name
				id
			}
		}
	}
`;

export const GET_DW_ENTITY_ADDRESSES = gql`
	query GetDWEntityAddresses($entity_id: bigint!){
		syncarto_dw_entity(where: {id: {_eq: $entity_id}}) {
			address {
				address
				address2
				city
				district
				countryid
				district2
				org_id
				postalcode
				id
				ext_id
			}
		}
	}
`;
export const GET_PROPERTIES = gql`
    query GetProperties {
      syncarto_dw_property {
        id
        name
      }
    }
`;

export const GET_DASHBOARD_WIDGET_TYPES = gql`
	query GetDashboardWidgetTypes {
		syncarto_app_dashboard_widget_type {
			base_height
			base_width
			description
			id
			name
		}		
	}
`;

export const CREATE_DASHBOARD_WIDGET_INSTANCE = gql`
	mutation insertDashboardWidgetInstances($data: syncarto_app_dashboard_widget_instance_insert_input!) {
		insert_syncarto_app_dashboard_widget_instance(objects: [$data]) {
			returning {
				id
			}
		}
	}
`;

export const UPDATE_DASHBOARD_WIDGET_INSTANCE = gql`
	mutation updateDashboardWidgetInstances($id: uuid!, $data: syncarto_app_dashboard_widget_instance_set_input!) {
		update_syncarto_app_dashboard_widget_instance(where: {id: {_eq: $id}}, _set: $data) {
			affected_rows
		}
	}
`;

export const DELETE_DASHBOARD_WIDGET_INSTANCE = gql`
mutation deleteDashboardWidgetInstances($id: uuid!) {
	delete_syncarto_app_dashboard_widget_instance(where: {id: {_eq: $id}}) {
		affected_rows
	}
}
`;

export const GET_DASHBOARDS_BY_ORG_ID = gql`
	query GetDashboardsByOrg($org_id: uuid!) {
		syncarto_app_dashboard(order_by: {created_at: desc}, where: {org_id: {_eq: $org_id}}) {
			id
			name
			org_id
			created_at
			updated_at
			org {
			  name
			  id
			}
		}
	}
`;

export const GET_DASHBOARDS = gql`
	query GetDashboards {
		syncarto_app_dashboard(order_by: {created_at: desc}) {
			id
			name
			org_id
			created_at
			updated_at
			org {
			  name
			  id
			}
		}
	}
`;

export const GET_DATA_DEFINITIONS = gql`
	query GetDataDefinitions {
		syncarto_app_data_definition(order_by: {name: asc}) {
			id
			name
			org_id
			definition
			citation
		}
	}
`;

export const DELETE_DASHBOARD = gql`
	mutation DeleteDashboard($id: uuid!) {
		delete_syncarto_app_dashboard(where: {id: {_eq: $id}}) {
			affected_rows
		}
		delete_syncarto_app_dashboard_widget_instance(where: {dashboard_id: {_eq: $id}}) {
			affected_rows
		}
	}
`;

export const UPDATE_DASHBOARD = gql`
	mutation UpdateDashboard($id: uuid!, $data: syncarto_app_dashboard_set_input!) {
		update_syncarto_app_dashboard(where: {id: {_eq: $id}}, _set: $data) {
			affected_rows
		}
	}
`;

export const CREATE_DASHBOARD = gql`
	mutation CreateDashboard($data: syncarto_app_dashboard_insert_input!) {
		insert_syncarto_app_dashboard(objects: [$data]) {
			returning {
				id
			}
		}
	}
`;

export const GET_DASHBOARD = gql`
query GetDashboard($id: uuid!) {
	syncarto_app_dashboard_by_pk(id: $id) {
	  id
	  name
	  org_id
	  updated_at
	  is_public
	  dashboard_widget_instances {
		dashboard_id
		dashboard_widget_type_id
		height
		id
		is_static
		location_x
		location_y
		title
		width
		config
		dashboard_widget_type {
		  base_height
		  base_width
		  description
		  name
		  id
		}
	  }
	}
  }
`;

export const GET_ORGS = gql`
	query GetOrgs {
		syncarto_app_org {
			id
			name
		}
	}
`;

export const GET_ORG_USER = gql`
	query GetUser($user_id: String!) {
		syncarto_app_org_user(where: {user_id: {_eq: $user_id}}) {
			id
			org {
				id
				name
				org_logo_64
				org_logo_bground
			}
			org_id
			role_id
			user_id
		}
  	}
`;

export const CREATE_ORG = gql`
	mutation CreateOrg($name:String!, $ownerId:String!) {
		insert_syncarto_app_org(objects: {name: $name, owner_id: $ownerId}) {
			returning {
				id
			}
		}
	}
`;


export const UPDATE_USER_PROFILE = gql`
	mutation updateUserProfile($id: String!, $data: syncarto_app_user_set_input!) {
		update_syncarto_app_user(where: {id: {_eq: $id}}, _set: $data) {
			affected_rows
		}
	}
`;

export const GET_USER_PROFILE = gql`
	query GetUserProfile($id: String!) {
		syncarto_app_user(where: {id: {_eq: $id}}) {
			id
			name
			email
		}
	}
`;

export const GET_USER_BY_EMAIL = gql`
	query GetUserByEmail($email: String!) {
		syncarto_app_user(where: {email: {_eq: $email}}) {
			id
			name
			email
		}
	}
`;

export const GET_ORG_USERS_WITH_ROLES = gql`
	query GetOrgUsers($org_id: uuid!) {
		syncarto_app_org_by_pk(id: $org_id) {
			id
			name
			org_users(distinct_on: user_id) {
			  user {
				id
				email
				name
				org_user(where: {org_id: {_eq: $org_id}}) {
				  id
				  role {
					name
					id
				  }
				}
			  }
			}
		  }
	}
`;

export const GET_ORG_USER_WITH_ROLES = gql`
	query GetOrgUser($org_id: uuid!, $user_id: String!) {
		syncarto_app_user_by_pk(id: $user_id) {
			email
			id
			name
			org_user(where: {org_id: {_eq: $org_id}}) {
			  id
			  role {
				id
				name
			  }
			}
		  }
	}
`;

export const GET_APP_ROLES = gql`
	query GetAppRoles {
		syncarto_app_role(where: {name: {_neq: "Super Admin"}}) {
			id
			name
		}
	}
`;

export const UPDATE_ORG_PROFILE = gql`
	mutation updateOrgProfile($id: uuid!, $data: syncarto_app_org_set_input!) {
		update_syncarto_app_org(where: {id: {_eq: $id}}, _set: $data) {
			affected_rows
		}
	}
`;

export const GET_ORG_PROFILE = gql`
	query GetOrgProfile($id: uuid!) {
		syncarto_app_org(where: {id: {_eq: $id}}) {
			id
			name
			org_logo_64
			org_logo_bground
		}
	}
`;

export const UPDATE_ORG_USER = gql`
	mutation UpdateUserOrgRole($id: Int!, $role_id: Int!) {
		update_syncarto_app_org_user(where: {id: {_eq: $id}}, _set: { role_id: $role_id} ) {
			returning {
				id
				org_id
				role_id
			}
		}
	}
`;

export const CREATE_USER = gql`
	mutation CreateAppUser($id: String!, $name: String!, $email: String!,$org_id: uuid!) {
		insert_syncarto_app_user(objects: {email: $email, id: $id, name: $name, org_id: $org_id}) {
			returning {	
				id
			}
		}
	}
`;	

export const CREATE_ORG_USER = gql`
	mutation CreateOrgUser($user_id: String!, $org_id: uuid!, $role_id: Int!) {
		insert_syncarto_app_org_user(objects: {org_id: $org_id, role_id: $role_id, user_id: $user_id}) {
			returning {
				id
			}
		}
	}
`;

export const DELETE_ORG_USER_BY_ID = gql`
	mutation DeleteOrgUser($id: Int!) {
		delete_syncarto_app_org_user(where: {id: {_eq: $id}}) {
			affected_rows
			returning {
			  id
			  org_id
			  role_id
			  user_id
			}
		}
	}
`;

export const DELETE_ORG_USER_BY_ORG_EMAIL= gql`
	mutation DeletergUserByEmail($org_id: uuid!, $email: String!) {
		delete_syncarto_app_org_user(where: {org_id: {_eq: org_id}, user_id: {_eq: $email}}) {
			affected_rows
			returning {
			  id
			  org_id
			  role_id
			  user_id
			}
		}
	}
`;

export const GET_DATA_SOURCES = gql`
	query GetDataSources($org_id: uuid!) {
		syncarto_app_data_source(where: {org_id: {_eq: $org_id}}) { 
			id
			stac_address
			min_date
			max_date
			collection_id
			title
		}
	}
`;

export const GET_DATA_SOURCES2 = gql`
  query GetAllDataSources2 {
    syncarto_app_data_source (order_by: {title: asc_nulls_last}) {
      title
      collection_id
      org_id
      min_date
      max_date
      extent
      stac_address
      capabilities
      citation
      min_zoom_level
      max_zoom_level
      stac_query_prefix
      date_display_resolution
      expr
      jq
      color_map
      color_ramp
      global_min
      global_max
      tile_server
      level
    }
  }
`;

export const GET_L2_DATA_SOURCES = gql`
  query GetAllDataSources($level: Int!) {
    syncarto_app_data_source (where: {level: {_eq: $level}, published: {_eq: true}}, order_by: {title: desc_nulls_last}) {
      title
      collection_id
      org_id
      min_date
      max_date
      extent
      stac_address
      capabilities 
      citation
      min_zoom_level
      max_zoom_level
      stac_query_prefix
      date_display_resolution
      expr
      jq
      color_map
      color_ramp
      global_min
      global_max
      tile_server
	  level
	  published
    }
  }
`;

export const GET_DATA_SOURCES3 = gql`
	query GetAllDataSourcesWithProps($org_id: uuid!) {
		syncarto_dw_property(where: {org_id: {_eq: $org_id}, data_source_id: {_gt: 0}}) {
		category_id
		data_source_id
		id
		name
		org_id
		shortcode
		type_id
		unit_id
		data_source {
			capabilities
			citation
			collection_id
			color_map
			color_ramp
			data_source_type_id
			date_display_resolution
			expr
			global_max
			global_min
			id
			is_ext
			is_public
			jq
			max_date
			max_zoom_level
			min_date
			min_zoom_level
			org_id
			process_catalog_id
			public_data_catalog_id
			stac_address
			stac_query_prefix
			template
			tile_server
			title
		}
		unit {
			abbrv
			name
			unit_type_id
		}
		}
	}
  `;

export const GET_SOIL_DATA_SOURCES = gql`
    query GetAllSoilDataSources($org_id: uuid!) {
		syncarto_dw_property(where: {
		  data_source_id: {_is_null: false},
		  org_id: {_eq: $org_id},
		  _or: [
			{property_category: {name: {_eq: "soil properties"}}},
			{shortcode: {_eq: "REFUSAL"}}
		  ]
		}) {
		  category_id
		  data_source_id
		  id
		  name
		  org_id
		  shortcode
		  type_id
		  unit_id
		  data_source {
			capabilities
			citation
			collection_id
			color_map
			color_ramp
			expr
			global_max
			global_min
			is_ext
			is_public
			jq
			max_date
			min_date
			max_zoom_level
			metadata
			min_zoom_level
			org_id
			process_catalog_id
			stac_address
			public_data_catalog_id
			stac_query_prefix
			template
			tile_server
			title
			data_source_type_id
			date_display_resolution
			id
		  }
		  property_category {
			id
			name
		  }
		  unit {
			abbrv
			name
			unit_type_id
		  }
		}
	}
	  
`;

export const ALL_LAYERS_QUERY = gql`
  query allLayers {
    syncarto_app_data_source (order_by: {title: asc_nulls_last}) {
      title
      collection_id
      min_date
      max_date
      extent
      stac_address
      capabilities
      citation
      min_zoom_level
      max_zoom_level
      stac_query_prefix
      date_display_resolution
      expr
      jq
      color_map
      color_ramp
      global_min
      global_max
      tile_server
    }
  }
`;

export const GET_SOIL_HORIZONS_BY_FIELD_ID = gql`
query GetSoilProfileSet($field_id: Int!) {
	landscan_soilprofilesets(where: {field_id: {_eq: $field_id}}) {
	  date_sampled
	  description
	  field_id
	  horizons_mapping
	  name
	  project_code
	  project_type_id
	  s3_key_horizons_csv
	}
  }
`;

export const GET_DATA_SOURCE = gql`
	query GetDataSource($id: Int!) {
		syncarto_app_data_source(where: {id: {_eq: $id}}) { 
			id
			data_source_type_id
			stac_address
			collection_id
			public_data_catalog_id
			process_catalog_id
			org_id
			min_date
			max_date
			title
			extent
			is_public
			is_ext
			template
			capabilities
			citation
			metadata
			min_zoom_level
			max_zoom_level
			stac_query_prefix
			date_display_resolution
			expr
			jq
			color_map
			color_ramp
			global_min
			global_max
			tile_server
		}
	}
`;

export const UPDATE_DATA_SOURCE = gql`
	mutation UpdateDataSource(
				$id: Int!, 
				$stac_address: String!,
                $title: String!,
                $collection_id: String!,
                $data_source_type_id: Int!,
                $public_data_catalog_id: Int!,
                $process_catalog_id: Int!, 
                $min_date: date!,
                $max_date: date!,
                $is_public: Boolean!,
                $is_ext: Boolean!,
                $template: String!,
                $capabilities: String!,
                $citation: String!,
                $min_zoom_level: Int!,
                $max_zoom_level: Int!,
                $metadata: String!,
                $stac_query_prefix: String!,
                $date_display_resolution: String!,
				$expr: String!,
				$jq: String!,
				$color_map: String!,
				$color_ramp: String!,
				$global_min: Float!,
				$global_max: Float!,
				$tile_server: String!,
			) {
		update_syncarto_app_data_source(
			where: {
				id: {_eq: $id}
			}, 
			_set: { 
                stac_address: $stac_address,
                title: $title,
                collection_id: $collection_id,
                data_source_type_id: $data_source_type_id,
                public_data_catalog_id: $public_data_catalog_id,
                process_catalog_id: $process_catalog_id, 
                min_date: $min_date,
                max_date: $max_date,
                is_public: $is_public,
                is_ext: $is_ext,
                template: $template,
                capabilities: $capabilities,
                citation: $citation,
                min_zoom_level: $min_zoom_level,
                max_zoom_level: $max_zoom_level,
                metadata: $metadata,
                stac_query_prefix: $stac_query_prefix,
                date_display_resolution: $date_display_resolution,
				expr: $expr,
				jq: $jq,
				color_map: $color_map,
				color_ramp: $color_ramp,
				global_min: $global_min,
				global_max: $global_max,
				tile_server: $tile_server
			} ) {
			returning {
				id
                stac_address
                title
                collection_id
                data_source_type_id
                public_data_catalog_id
                process_catalog_id
                min_date
                max_date
                is_public
                is_ext
                template
                capabilities
                citation
                min_zoom_level
                max_zoom_level
                metadata
                stac_query_prefix
                date_display_resolution
				expr
				jq
				color_map
				color_ramp
				global_min
				global_max
				tile_server
			}
		}
	}
`;

export const CREATE_DATA_SOURCE = gql`
	mutation CreateDataSource(
		$org_id: uuid!,
		$stac_address: String!,
		$title: String!,
		$collection_id: String!,
		$data_source_type_id: Int!,
		$public_data_catalog_id: Int!,
		$process_catalog_id: Int!, 
		$min_date: date!,
		$max_date: date!,
		$is_public: Boolean!,
		$is_ext: Boolean!,
		$template: String!,
		$capabilities: String!,
		$citation: String!,
		$min_zoom_level: Int!,
		$max_zoom_level: Int!,
		$metadata: String!,
		$stac_query_prefix: String!,
		$date_display_resolution: String!,
		$expr: String!,
		$jq: String!,
		$color_map: String!,
		$color_ramp: String!,
		$global_min: Float!,
		$global_max: Float!,
		$tile_server: String!
	) {
		insert_syncarto_app_data_source(
			objects: {
				org_id: $org_id,
				stac_address: $stac_address,
                title: $title,
                collection_id: $collection_id,
                data_source_type_id: $data_source_type_id,
                public_data_catalog_id: $public_data_catalog_id,
                process_catalog_id: $process_catalog_id, 
                min_date: $min_date,
                max_date: $max_date,
                is_public: $is_public,
                is_ext: $is_ext,
                template: $template,
                capabilities: $capabilities,
                citation: $citation,
                min_zoom_level: $min_zoom_level,
                max_zoom_level: $max_zoom_level,
                metadata: $metadata,
                stac_query_prefix: $stac_query_prefix,
                date_display_resolution: $date_display_resolution,
				expr: $expr,
				jq: $jq,
				color_map: $color_map,
				color_ramp: $color_ramp,
				global_min: $global_min,
				global_max: $global_max,
				tile_server: $tile_server
			}) {
			returning {	
				id
                stac_address
                title
                collection_id
                data_source_type_id
                public_data_catalog_id
                process_catalog_id
                min_date
                max_date
                is_public
                is_ext
                template
                capabilities
                citation
                min_zoom_level
                max_zoom_level
                metadata
                stac_query_prefix
                date_display_resolution
				expr
				jq
				color_map
				color_ramp
				global_min
				global_max
				tile_server
			}
		}
	}
`;	

export const GET_DATA_PROPERTIES = gql`
	query GetDataProperties($org_id: uuid!) {
		syncarto_dw_property(where: {org_id: {_eq: $org_id}}) { 
			id
			name
			org_id
			category_id
			shortcode
			type_id
			unit_id
			property_type { 
				id
				name
			}
			property_category {
				id
				name
			}
		}
	}
`;

export const GET_DATA_PROPERTY = gql`
	query GetDataProperty($id: smallint!) {
		syncarto_dw_property(where: {id: {_eq: $id}}) { 
			id
			name
			org_id
			category_id
			shortcode
			type_id
			unit_id
			property_type { 
				id
				name
			}
			property_category {
				id
				name
			}
		}
	}
`;

export const GET_DATA_PROPERTY_UNITS = gql`
	query GetDataPropertyUnits {
		syncarto_dw_unit { 
			id
			unit_type_id
			name
			abbrv
		}
	}
`;

export const GET_DATA_PROPERTY_CATEGORIES = gql`
	query GetDataPropertyCategories($org_id: uuid!) {
		syncarto_dw_property_category(where: {org_id: {_eq: $org_id}}) { 
			id
			name
		}
	}
`;

export const GET_DATA_PROPERTY_TYPES= gql`
	query GetDataPropertyTypes {
		syncarto_dw_property_type { 
			id
			name
		}
	}
`;

export const UPDATE_DATA_PROPERTY = gql`
	mutation UpdateDataProperty(
				$id: smallint!, 
				$name: String!,
                $shortcode: String!,
                $category_id: smallint!,
                $unit_id: smallint!,
                $type_id: Int!,
			) {
		update_syncarto_dw_property( 
			where: {
				id: {_eq: $id}
			}, 
			_set: {
				name: $name,
				category_id: $category_id,
				shortcode: $shortcode,
				type_id: $type_id,
				unit_id: $unit_id
			} ) {
			returning {
				id
				name
				category_id
				shortcode
				type_id
				unit_id
			}
		}
	}
`;

export const CREATE_DATA_PROPERTY = gql`
	mutation CreateDataProperty(
		$org_id: uuid!,
		$name: String!,
		$shortcode: String!,
		$category_id: smallint!,
		$unit_id: smallint!,
		$type_id: Int!,
	) {
		insert_syncarto_dw_property(
			objects: {
				org_id: $org_id,
				name: $name,
				shortcode: $shortcode,
				category_id: $category_id,
				unit_id: $unit_id,
				type_id: $type_id,
			}) {
			returning {	
				org_id
				name
				shortcode
				category_id
				unit_id
				type_id
			}
		}
	}
`;	

export const GET_SHORTCODES_BY_ORG = gql`
	query GetShortcodeByOrg($org_id: uuid!) {
		syncarto_dw_property(where: {org_id: {_eq: $org_id}}) { 
			shortcode
		}
	}
`;


// farm manager
export const GET_ALL_CROPS = gql`
	query GetAllCrops {
		landscan_crops(order_by: {name: asc}) {
            crop_id
			name
			description
        }
	}
`;

export const GET_ALL_CROP_VARIETIES = gql`
	query GetAllCropVarieties {
		landscan_varieties(order_by: {name: asc}) {
			variety_id
			crop_id
			name
			description
		}
	}
`;

export const GET_GROWERS2 = gql`
	query GetGrowers {
		landscan_growers(order_by: {name: asc}) {
			grower_id
			name
			description
		}
	}  
`;

export const GET_FARMS = gql`
	query GetFarms {
		landscan_farms(order_by: {name: asc}) {
			farm_id
			grower_id
			name
			description
		}
	}  
`;

export const GET_FIELDS = gql`
	query GetFields {
	landscan_fields(order_by: {name: asc, field_id: asc}) {
		field_id
		name
		description
		grower_id
		farm_id
		crop_id
		variety_id
		year_planted
		row_spacing_unit_abbrev
		plant_spacing_unit_abbrev
		area_unit_abbrev
		row_spacing
		plant_spacing
		area
		acres
		url
		geom
		farm {
			farm_id
			name
			description
			grower {
				grower_id
				name
				description
			}
		}
	  }
	}
`;

export const GET_FIELDS_WITH_DETAILS = gql`
	query GetFieldsWithDetails {
			landscan_fields {
			field_id
			name
			description
			geom
			farm {
				farm_id
				name
				description
				grower {
					grower_id
					name
					description
				}
			}
		}
	}  
`;

export const CREATE_FIELD = gql`
mutation CreateField($data: landscan_fields_insert_input!) {
	insert_landscan_fields(objects: [$data]) {
	  returning {
		farm_id
		field_id
		name
		description
		geom
	  }
	}
  }
`;

export const CREATE_FIELDS = gql`
mutation CreateFields($data: [landscan_fields_insert_input!]!) {
	insert_landscan_fields(objects: $data) {
	  returning {
		field_id
	  }
	}
  }
`;

export const UPDATE_FIELD = gql`
	mutation UpdateField($id: Int!, $data: landscan_fields_set_input!) {
		update_landscan_fields(where: {field_id: {_eq: $id}}, _set: $data) {
			affected_rows
		}
	}
`;

export const DELETE_FIELD = gql`
	mutation DeleteField($id: Int!) {
		delete_landscan_fields(where: {field_id: {_eq: $id}}) {
			affected_rows
		}
	}
`;

export const CREATE_GROWER = gql`
	mutation CreateGrower($data: landscan_growers_insert_input!) {
		insert_landscan_growers(objects: [$data]) {
		returning {
			grower_id
		}
	}
}`;

export const CREATE_FARM = gql`
	mutation CreateFarm($data: landscan_farms_insert_input!) {
		insert_landscan_farms(objects: [$data]) {
		returning {
			farm_id
		}
	}
}`;


// subscriptions
export const GET_SUBSCRIPTIONS = gql`
query GetSubscriptions {
	syncarto_app_subscription {
	  id
	  ext_id
	  start_date
	  end_date
	  status
	}
}`;

export const GET_ACTIVE_SUBSCRIPTIONS = gql`
query GetActiveSubscriptions {
	syncarto_app_subscription(where: {status: {_eq: "1"}}) {
	  id
	  org_id
	  ext_id
	  cust_id
	  lic_id
	  start_date
	  end_date
	  status
	  units
	  license {
		id
		name
		ext_id
		description
	  }
	}
  }
`;

export const GET_SOIL_INTERPRETATIONS = gql`
	query GetSoilInterpretations {
		landscan_soilinterpretations {
		external_id
		interpretation_group
		interpretation_id
		name
		}
	}
`;

export const GET_PROPERTY_UNITS = gql`
	query GetPropertyUnits($org_id: uuid!) {
		syncarto_dw_property(where: {org_id: {_eq: $org_id}}) {
		  unit {
			id
			name
			abbrv
			unit_type_id
		  }
		  name
		  id
		  shortcode
		  type_id
		}
	  }
`;

